/* newsloader.js: load more news on click */

import $ from 'jquery';

export function init() {
	$('body').on('click', '.news-load-more', function(event) {
		var button = $(this);

		button.attr('disabled', 'disabled');

		$.get('/news/from?from='+button.data('from'), function (data) {
			$('.news-container').append(data);
			button.parents('.news-load-more-container').remove();
		});

	});
}



//////////////////
// WEBPACK FOOTER
// ./public/js/~/newsloader.js
// module id = 4
// module chunks = 0